<template>
	<span columns="1" rows="12" class="max-w-full" v-click-outside="closeDropdown" ref="span">
		<Input :placeholder="$root.appConfig.language.guestsAndRooms" :fullwidth="true" :icon="true" :modelValue="guestRoom" @click.native="openDropdown()" :hasInputSlot="true">
			<template v-slot:input>
				<input
					readonly
					class="inp"
					type="text"
					name="roomsguests"
					:value="guestRoom"
				/>
			</template>
			<template v-slot:after-icon>
				<UserIcon/>
			</template>
		</Input>

		<MobileModal :visible="dropdownOpen" @close="closeDropdown">
			<div class="gr-wrap">
				<H level="4">{{ $root.appConfig.language.guestsAndRooms }}</H>
				<FormRow>
					<LabelWithDescription :label="$root.appConfig.language.rooms" :info="$root.appConfig.language.roomsInfo">
						<InputNumber name="rooms" :min="1" :max="10" @change="updateRooms" :modelValue="rooms"></InputNumber>
					</LabelWithDescription>
				</FormRow>
				<FormRow>
					<LabelWithDescription :label="$root.appConfig.language.guestsRoom" :info="$root.appConfig.language.guestsInfo">
						<InputNumber name="guests" :min="1" :max="2" @change="updateGuests" :modelValue="guests"></InputNumber>
					</LabelWithDescription>
				</FormRow>

				<div class="spacer"></div>
				<footer>
					<div class="legend">
						{{ guestRoom }}
					</div>
					<a href="#" class="button red fullwidth" @click.prevent="closeDropdown">
						{{ $root.appConfig.language.updateGuestsRooms }}
					</a>
				</footer>
			</div>
		</MobileModal>
	</span>
</template>
<script>
import ClickOutside from 'vue-click-outside'
import {
	H,
	UserIcon,
	Input,
	FormRow,
	LabelWithDescription,
	InputNumber,
	MobileModal,
	//Button,
} from 'citizen-shared-components';
export default {
	name: 'RoomGuestInput',
	components: {
		H,
		UserIcon,
		Input,
		FormRow,
		LabelWithDescription,
		// Button,
		InputNumber,
		MobileModal,
	},
	props: {
		guests: Number,
		rooms: Number,
	},
	data(){
		return {
			dropdownOpen: false,
		}
	},
	computed: {
		guestRoom(){
			return `${this.rooms} ${this.rooms > 1 ? this.$root.appConfig.language.rooms : this.$root.appConfig.language.room} - ${this.guests}  ${this.guests > 1 ? this.$root.appConfig.language.guestsRoom : this.$root.appConfig.language.guestRoom}`
		}
	},
	methods: {
		openDropdown(){
			this.$emit('open')
			this.dropdownOpen = true
		},
		closeDropdown(){
			if(this.dropdownOpen === true) {
				this.$emit('close')
				this.dropdownOpen = false
			}
		},
		updateRooms(rooms){
			this.$emit('changeRooms', rooms)
		},
		updateGuests(guests){
			this.$emit('changeGuests', guests)
		},
	},
	directives: {
		ClickOutside
	},
}
</script>
<style lang="scss" scoped>
@import "@/assets/styles/app.scss";
@import "@/assets/styles/utils/_mixins.scss";
h4 {
	margin-bottom: 16px;
}
.spacer {
	flex-grow: 1;
}
.legend {
	font-family: var(--font-family-bold);
	font-size: 14px;
	line-height: 20px;
	text-align: center;
	margin: 16px auto 12px;
}
.gr-wrap {
	display: flex;
	flex-direction: column;
	height: calc(100vh - var(--space-56) - var(--space-16));
	background: var(--primary-white);

	@supports (padding-bottom: env(safe-area-inset-bottom)) {
		@include mdx {
			padding-bottom: env(safe-area-inset-bottom);
		}
	}

	/* Safari Only -- take this out later on? */
	@supports selector(:nth-child(1 of x)) {
		@include mdx {
			padding-bottom: 78px;
		}
	}

	> footer {
		background: var(--primary-white);
		box-shadow: var(--shadow);

		color: inherit;

		margin-left: calc(-1 * var(--space-16));
		margin-right: calc(-1 * var(--space-16));
		width: calc(100% + var(--space-16) + var(--space-16)	);
		padding: 0 var(--space-16);
	}
}
.button {
	display: inline-flex;
	text-align: left;
	white-space: nowrap;
	cursor: pointer;
	overflow: hidden;
	-webkit-appearance: none;
	appearance: none;
	text-decoration: none !important;
	margin: 0;
	align-items: center;
	justify-content: center;
	background: none;

	border: 1px solid transparent;
	border-radius: var(--border-radius);
	transition: var(--transition-all);
	background: var(--primary-red);
	color: var(--primary-white);
	font-size: var(--font-size-btn-small);
	font-family: var(--font-family-bold), sans-serif;

	padding: var(--space-16) var(--space-32);
	line-height: var(--line-height-btn);

	&:hover {
		background: var(--color-red-hover);
	}
	&:focus {
		background: var(--color-red-focus);
	}
	&:active {
		background: var(--color-red-pressed);
	}

	&:disabled {
		pointer-events: none;
		background: var(--color-red-disabled);
		color: var(--color-black-disabled);
		svg, ::v-deep svg {
			path{
				fill: var(--color-black-disabled);
			}
		}
	}

	&.old{
		border-radius: 0px;
	}
}

@include md {
	.gr-wrap {
		display: block;
		height: auto;
		padding: 0 18px 16px;

		h2,h3,h4,
		footer {
			display: none;
		}

		.form-row {
			margin: 0;
			padding: 16px 0 0 0;

			.fieldset {
				margin: 0;
				width: 100%;
			}
		}
	}
}
</style>
<style>
.gr-wrap .label {
	color: inherit;
}
</style>